import axiosInstance from '../axios/axiosInstance';
import { SkillType } from '../model/response';

export const findAllSkillType = async () => {
  const { data } = await axiosInstance.get<SkillType[]>('skill-types', { params: { fromCMS: true } });
  return data;
};

export const toggleSkillTypeWebviewActive = async (id: string) => {
  await axiosInstance.patch(`skill-types/${id}/toggle-web-view-active`);
};
